import axios from "axios";
import { useQuery } from "react-query";
import { getHeader } from "../utils/util";
import { API_ENDPOINT } from "../utils/constants";

const useGetDesignations = () => {
  return useQuery({
    queryKey: ["get-designations"],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}admin/get-designations`,
        getHeader()
      );
      return response.data;
    },

    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useGetDesignations;
